<template>
  <div id="detailQuestionView">
    <a-row>
      <a-col :md="12" :xs="24">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" title="题目">
            <a-card v-if="data" :title="data.title">
              <template #extra>
                <a-space>
                  <a-tag
                    color="#7bc616"
                    v-for="(tag, index) in data.tags"
                    :key="index"
                    >{{ tag }}
                  </a-tag>
                </a-space>
              </template>
              <a-descriptions
                title="判题信息"
                :column="{ xs: 1, md: 2, lg: 3 }"
                layout="inline-horizontal"
              >
                <a-descriptions-item label="时间限制">
                  <a-tag>{{ data?.judgeConfig?.timeLimit ?? 0 }} ms</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="内存限制">
                  <a-tag>{{ data?.judgeConfig?.memoryLimit ?? 0 }} kb</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="堆栈限制">
                  <a-tag>{{ data?.judgeConfig?.stackLimit ?? 0 }} kb</a-tag>
                </a-descriptions-item>
              </a-descriptions>
              <MDViewer :value="data.content || ''" />
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="2" title="题解">
            <a-card>
              <MDViewer :value="data.answer || ''" />
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-col>
      <a-col :md="12" :xs="24">
        <a-select
          style="width: 160px; margin-bottom: 7px"
          :trigger-props="{ autoFitPopupMinWidth: true }"
          v-model="submitParams.language"
        >
          <a-option>java</a-option>
          <a-option>cpp</a-option>
          <a-option>python</a-option>
        </a-select>
        <CodeEditor
          :language="submitParams.language"
          :handle-change="codeChange"
        />
        <a-button type="primary" style="margin-top: 20px" @click="doSubmit"
          >提交代码
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script setup lang="ts">
import { MyAxios } from "@/plugins/axios";
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import CodeEditor from "@/components/CodeEditor.vue";
import MDViewer from "@/components/MDViewer.vue";

const route = useRoute();
const data = ref({});
const submitParams = ref({
  questionId: route.query.id,
  language: "java",
  code: "",
});
const loadData = async () => {
  await MyAxios.get("/question/get/vo?id=" + route.query.id).then((res) => {
    if (res.data.code === 0) {
      data.value = res.data.data;
      // console.log(data.value);
    } else {
      message.error("加载失败：" + res.data.message);
    }
  });
};
onMounted(() => {
  loadData();
});
const codeChange = (code: string) => {
  submitParams.value = {
    ...submitParams.value,
    code: code,
  };
};
const languageChange = (language: string) => {
  submitParams.value = {
    ...submitParams.value,
    language: language,
  };
};
const doSubmit = () => {
  MyAxios.post("/question/question_submit/do", submitParams.value).then(
    (res) => {
      if (res.data.code === 0) {
        message.success("提交成功，判题中......");
      } else {
        message.error("提交失败: " + res.data.message);
      }
    }
  );
};
</script>
<style scoped>
#detailQuestionView {
}
</style>
